$(document).ready(function() {

    // Display pop ups
    var openPopupSent = Cookies.get('openPopupSent');

    if (openPopupSent == 'yes') {
        var successPopUpShown = Cookies.get('openPopupSent');
        if(successPopUpShown) {
            // No action necessary
        } else {
            // Not Sign Up Page
            if(window.location.pathname != '/sign-up') {
                // Display form with messages and set cookie for success pop up
                displayOpenPopup();
                Cookies.set('successPopUpShown', true);
            }
        }
    } else {

        // Not Sign Up Page
        if(window.location.pathname != '/sign-up') {
            // Open Popup
            setTimeout(function(){

                var openPopupShown = Cookies.get('openPopupShown');
                var exitPopupShown = Cookies.get('exitPopupShown');

                if(openPopupShown){
                    // Open pop up already shown. Display exit pop up if not shown

                    if(exitPopupShown){
                        // Exit pop up already shown. No action neccessary
                    } else {
                        lastFocus = document.activeElement;
                        // Display Exit Popup
                        $(document).one('mouseleave', leaveFromTop);

                        function leaveFromTop(e){
                            $open_popup_closed = $('#open-popup-modal').is(":hidden");
                            // Open modal closed and cursor is less than 60px is close enough to the top
                            if($open_popup_closed ) {
                                displayExitPopup();
                                Cookies.set('exitPopupShown', 'yes', { expires: 1 });
                            }
                        }
                    }
                } else {
                    // Display Open Pop Up
                    lastFocus = document.activeElement;
                    displayOpenPopup();
                }


                Cookies.set('openPopupShown', 'yes', { expires: 1 });

            }, 4000);

        }

    }

    function displayOpenPopup(){
        $("#open-popup-modal").modal('show');
    }

    function displayExitPopup(){
        $("#exit-popup-modal").modal('show');
    }


});